import { useState } from 'react';
import { extractErrorMessage } from '../utils/error.utils';
import axios from 'axios';
import { SEARCH_DEVICE } from '../config/api';
import { toast } from 'react-toastify';

const useDevices = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string>();

    const searchDevice = async (sn: string | null) => {
        if (!sn) return {};

        setIsLoading(true);
        setError('');

        try {
            const result = await axios.get(SEARCH_DEVICE(sn));
            return result?.data;
        } catch (err: any) {
            toast.error(extractErrorMessage(err), { toastId: 'error', autoClose: false });
        } finally {
            setIsLoading(false);
        }
    };

    return { searchDevice, isLoading, error };
};

export default useDevices;
